<div class="cald_dialog">
    <div class="cald_header">
        <button class="close-dialog-button sap-icon" data-dismiss="modal" (click)="cancel()">&#xe03e;</button>
        <h2>{{ 'Admin.SelectColumns.DisplaySettings' | translate }}</h2>
    </div>
    <div class="cald_content cpq-scroll">
        <div class="select-list">
            <div class="display-head justified-container">
                <div>{{ 'Admin.Datatable.SelectColumns'| translate }}</div>
                <div class="select-all" (click)="toggleSelectAllColumns()" [class.select-all-active]="selectedItems.length === items.length">
                    <span class="sap-icon">&#xe05b;</span>
                </div>
            </div>
            <cpq-list-box [items]="items" [(selectedItems)]="selectedItems"></cpq-list-box>
        </div>
        <div class="display-down">
            <span>{{ selectedItems.length }} {{ 'Admin.Datatable.ItemsSelected'| translate }}</span>
        </div>
    </div>

    <div class="form-inline cald_dialog_buttonbar">
        <button type="button" class="btn btn-primary fiori3-btn-primary" (click)="save()">{{ 'Admin.Msg.Save'| translate }}</button>
        <button class="btn btn-tertiary fiori3-btn-tertiary" (click)="cancel()">{{ 'Admin.Msg.CancelButton' | translate }}</button>
    </div>
</div>